const url = process.env.API_URL || 'http://wealthbar.test/advisor_api';
const host = url.replace(/\/?advisor_api\/?/, '');

export { url, host };
